import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSending(true);
    try {
      const { data } = await axios.post(`${API}/subscribe`, { email });
      setDone(true);
      setEmail("");
      toast.success(
        data.status === "already_subscribed"
          ? "You're already on the list — thank you."
          : "Thank you for subscribing."
      );
    } catch (err) {
      toast.error("That didn't go through. Please check the email and try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="newsletter-signup">
      <p className="text-xs font-medium uppercase tracking-[0.25em] text-brass">Dawn Dispatch</p>
      <p className="mt-5 max-w-xs text-sm leading-relaxed text-ivory/60">
        Field notes from the forest, a few times a year. Wake up to the sounds of Himalayan birds.
      </p>
      {done ? (
        <p data-testid="newsletter-success" className="mt-5 font-serif text-base italic text-brass">
          Thanks for subscribing — see you in the forest.
        </p>
      ) : (
        <form onSubmit={submit} className="mt-5 flex max-w-xs items-center border border-ivory/20 focus-within:border-brass transition-colors duration-300">
          <input
            data-testid="newsletter-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email"
            className="w-full bg-transparent px-4 py-3 text-sm text-ivory placeholder:text-ivory/35 focus:outline-none"
          />
          <button
            data-testid="newsletter-submit-btn"
            type="submit"
            disabled={sending}
            className="flex-shrink-0 bg-brass px-4 py-3 text-[11px] font-semibold tracking-[0.2em] text-charcoal transition-colors duration-300 hover:bg-[#B89B6A] disabled:opacity-60"
          >
            {sending ? "…" : "JOIN"}
          </button>
        </form>
      )}
    </div>
  );
}
